import { round } from 'lodash';

export function measureTableColumnWidthsCssPx(tableEl: HTMLTableElement) {
  const fromFirstRow = measureWidthsFromFirstRow(tableEl);
  if (fromFirstRow.length > 0) {
    return fromFirstRow;
  }

  return measureWidthsFromColumnGroup(tableEl);
}

export function listTableElementsInEditor(editorRoot: HTMLElement) {
  return Array.from(
    editorRoot.querySelectorAll('[data-content-type="table"] table'),
  ).filter(
    (element): element is HTMLTableElement =>
      element instanceof HTMLTableElement,
  );
}

export function findTableElementForBlock(
  editorRoot: HTMLElement,
  blockId: string,
  tableElementsByIndex: Array<HTMLTableElement>,
  tableIndex: number,
) {
  const escapedId =
    typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
      ? CSS.escape(blockId)
      : blockId;
  const blockEl = editorRoot.querySelector(`[data-id="${escapedId}"]`);
  if (blockEl) {
    const tableEl = blockEl.querySelector('[data-content-type="table"] table');
    if (tableEl instanceof HTMLTableElement) {
      return tableEl;
    }
  }

  return tableElementsByIndex[tableIndex] ?? null;
}

function parsePositivePx(value: string | null | undefined) {
  if (!value) {
    return 0;
  }
  const parsed = Number(value.replace(/px$/i, '').trim());
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return 0;
  }
  return round(parsed);
}

function measureCellWidthCssPx(cell: HTMLTableCellElement) {
  const fromOffset = cell.offsetWidth;
  if (fromOffset > 0) {
    return round(fromOffset);
  }

  const fromRect = cell.getBoundingClientRect().width;
  if (fromRect > 0) {
    return round(fromRect);
  }

  return 0;
}

function measureWidthsFromColumnGroup(tableEl: HTMLTableElement) {
  const columns = tableEl.querySelectorAll('colgroup > col');
  if (columns.length === 0) {
    return [];
  }

  const widths: Array<number> = [];
  for (const column of columns) {
    const element = column as HTMLElement;
    const width =
      parsePositivePx(element.style.width) ||
      parsePositivePx(element.getAttribute('width'));
    widths.push(width);
  }

  if (widths.length > 0 && widths.every((width) => width > 0)) {
    return widths;
  }

  return [];
}

function measureWidthsFromFirstRow(tableEl: HTMLTableElement) {
  const firstRow = tableEl.querySelector('tbody tr, tr');
  if (!firstRow) {
    return [];
  }

  const widths: Array<number> = [];

  for (const cell of firstRow.querySelectorAll('th, td')) {
    const tableCell = cell as HTMLTableCellElement;
    const colspan = tableCell.colSpan || 1;
    const width = measureCellWidthCssPx(tableCell);

    if (colspan === 1) {
      widths.push(width);
      continue;
    }

    const perColumn = width > 0 ? round(width / colspan) : 0;
    for (let column = 0; column < colspan; column++) {
      widths.push(perColumn);
    }
  }

  return widths;
}
